import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import { Button } from './ui/button';

interface LoadMoreButtonProps {
  onClick: () => void;
  className?: string;
  isScan?: boolean;
}

export const LoadMoreButton = ({
  onClick,
  className,
  isScan = false,
}: LoadMoreButtonProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn('flex justify-center py-2 border-t', className)}>
      <Button
        variant='outline'
        className={cn(
          'px-4 text-sm h-7 border-blue-500 text-blue-500 hover:text-blue-500 hover:bg-blue-50',
          isScan &&
            'border-primary first:text-primary hover:text-primary hover:bg-primary-50'
        )}
        onClick={onClick}
      >
        {t('load_more')}
      </Button>
    </div>
  );
};
